import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Popover } from 'primeng/popover';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { WayToPayImportModel } from 'src/app/models/imports/way-to-pay-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CashReceiptService } from 'src/app/services/wallet/cash-receipt.service';

@Component({
  selector: 'app-way-to-pay-import',
  templateUrl: './way-to-pay-import.component.html',
  styleUrls: ['./way-to-pay-import.component.scss'],
  standalone: false
})
export class WayToPayImportComponent implements OnInit {

  @ViewChild('information') informationPopover!: Popover;

  private readonly branchService = inject(BranchService);
  private readonly cashReceiptService = inject(CashReceiptService);
  private readonly companyService = inject(CompanyService);
  private readonly enterpriseService = inject(EnterpriseService);
  private readonly formBuilder = inject(FormBuilder)
  private readonly headerService = inject(HeaderService);
  private readonly optionWindowService = inject(OptionWindowService);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly router = inject(Router);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  branchId: number = 0;
  branchCode: number | null = null;
  companyId: number = 0;
  companyCode: number | null = null;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  enterpriseId: number = 0;
  enterpriseCode: number | null = null;
  eventFile: any;
  errorWayToPay: number = 0;
  formImport: FormGroup = new FormGroup({});
  isChargeAccount: boolean = false;
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listClasses: any[] = [
    { label: "Facturas", value: 1 },
    { label: "Cuentas Cobro", value: 6 }
  ];
  listCompanies: any[] = [];
  listEnterprises: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = 'Ningún archivo seleccionado.';
  nameWindow: string = "Importación Formas de Pago";
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  url: string = "";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;
  wayToPayAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;

  async ngOnInit() {
    this.validateForm();
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    await this.getCompanies();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.wayToPayAlerts || this.wayToPayAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.cashReceiptService.exportImportErrors(this.wayToPayAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionFormasDePago_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.cashReceiptService.downloadGuideImportWayToPay().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaFormasDePago.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  async getCompanies() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),
      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener la lista de compañías.', error);
      return false;
    }
  }

  async getAllLists(...listsToLoad: Array<'companies' | 'branches'>) {
    try {
      const lists = {
        companies: async () => {
          this.listCompanies = await firstValueFrom(this.companyService.getAllCompaniesForSelectAsync());
        },
        branches: async () => {
          this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.companies()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getBranch(branchId: number) {
    if (branchId != null && branchId != 0) {
      this.branchId = branchId;
      const branch = this.listBranches.find(x => x.value == branchId);
      this.branchCode = branch.code;
      this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
    } else {
      this.branchCode = null;
      this.branchId = 0;
      this.listEnterprises = [];
    }
  }

  async getCompany(companyId: number | null) {
    if (!companyId) {
      this.companyId = 0;
      this.companyCode = 0;
      this.listBranches = [];
      this.validateForm();
      return;
    }

    const company = this.listCompanies.find(x => x.value == companyId);
    this.companyId = companyId;
    this.companyCode = company.code;
    await this.getAllLists('branches');
  }

  async getEnterprise(enterpriseId: number | null) {
    if (enterpriseId != null && enterpriseId != 0) {
      this.enterpriseId = enterpriseId;
      const enterprise = this.listEnterprises.find(x => x.value == enterpriseId);
      this.enterpriseCode = enterprise.code;
    } else {
      this.enterpriseId = 0;
      this.companyCode = null;
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    this.isChargeAccount = !url.startsWith('cash-receipt/register');
    try {
      await this.getPermissionProfileByUrl();
      this.getPermissionsForUserByWindow();
    } catch (error) {
      console.error('Error al obtener los permisos del perfil por URL.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    if (this.isChargeAccount) {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceiptChargeAccount));
      this.companyId = this.userAuthenticated.companyId;
    } else {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceipt));
      this.companyId = this.userAuthenticated.companyId;
    }
  }

  async getPermissionProfileByUrl() {
    try {
      const baseUrl = this.url.split('/')[0];
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(baseUrl));
      if (!this.permissionUpdatable) {
        this.disabledDetail = true;
        this.disabledForm = true;
        setTimeout(() => this.formImport.disable());
      }
    } catch (error) {
      this.permissionUpdatable = false;
      console.error('Error al obtener el permiso actualizable por URL.', error);
    }
  }

  openToggle(event: any) {
    this.informationPopover.toggle(event);
  }

  importWayToPay() {
    this.wayToPayAlerts = [];
    this.errorWayToPay = 0;
    this.visibleTxt = false;
    if (!this.formImport.valid) {
      this.showValidationMessages();
      return;
    }
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<WayToPayImportModel>();
    let row: WayToPayImportModel;
    let counter: number = 0, consecutiveCashReceipt: number, isChargeAccount: boolean,
      wayToPayCode: number = 0, valueWayToPay: number = 0;
    if (input.files[0]) {
      readXlsxFile(input.files[0]).then(async (rows) => {
        if (rows.length <= 1) {
          this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar`);
          return;
        }
        rows.splice(0, 1);

        isChargeAccount = this.formImport.get("bussinessDocumentsClassId")?.value == BussinessDocumentsClassEnums.cuentaCobro;

        rows.forEach(element => {
          counter = counter + 1;
          let rowHasError = false;

          // A. Código Compañía:
          const companyCode = parseFloat(element[0] as string);
          if (isNaN(companyCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. El código de la compañía no es válido.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }
          if (companyCode != this.companyCode) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. La compañía del archivo no es igual a la compañía seleccionada.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }

          // B. Código Sucursal:
          const branchCode = parseFloat(element[1] as string);
          if (isNaN(branchCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. El código de la sucursal no es válido.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }
          if (branchCode != this.branchCode) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. La sucursal del archivo no es igual a la sucursal seleccionada.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }

          //C. Código Empresa:
          const enterpriseCode = parseFloat(element[2] as string);
          if (isNaN(enterpriseCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna C. El código de la empresa no es válido.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }
          if (enterpriseCode != this.enterpriseCode) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna C. La empresa del archivo no es igual a la empresa seleccionada.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }

          //D. Consecutivo de recibo:
          consecutiveCashReceipt = parseFloat(element[3] as string);
          if (isNaN(consecutiveCashReceipt)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. El número de recibo no es válido.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }

          //E. Forma de Pago:
          wayToPayCode = parseFloat(element[4] as string);
          if (isNaN(wayToPayCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna E. Forma de pago no es válido.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }

          //F. Valor a pagar:
          valueWayToPay = parseFloat(element[5] as string);
          if (isNaN(valueWayToPay)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna F. Valor Forma de pago no es válido.`;
            this.wayToPayAlerts.push(alert);
            rowHasError = true;
          }

          if (!rowHasError) {
            row = new WayToPayImportModel(counter, this.companyId, this.branchId, this.enterpriseId, consecutiveCashReceipt, isChargeAccount, wayToPayCode, valueWayToPay);
            rowsImports.push(row);
          } else {
            isOk = false;
          }
        });

        if (isOk && rowsImports.length > 0) {
          try {
            const response = await firstValueFrom(this.cashReceiptService.importWayToPay(rowsImports));
            this.loadPreInvoicingModel = response;
            this.wayToPayAlerts = response?.alerts ?? [];
            this.errorWayToPay = response?.preInvoicingStateId;

            if (this.errorWayToPay === 1) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast(
                'error',
                'La importación terminó con errores, puede exportarlos si lo desea.',
                'ERROR');
            } else if (this.wayToPayAlerts.length > 0) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
            } else {
              this.visibleTxt = false;
              this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
            }
            this.clearInputFile();
          } catch (error) {
            this.nameFile = 'Ningún archivo seleccionado.';
            console.error('Error al importar las reparaciones.', error);
          }
          (<HTMLInputElement>document.getElementById('fileImport')).value = '';
        } else {
          this.errorWayToPay = 1;
          this.visibleTxt = true;
          this.toastHandlerService.showToast(
            'error',
            'La importación terminó con errores, puede exportarlos si lo desea'
          );
        }
      });
    } else {
      this.toastHandlerService.showToast('error', 'No ha seleccionado ningún archivo.');
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatoria.',
      },
      branchId: {
        required: 'La sucursal es obligatoria.',
        min: 'La sucursal es obligatoria.'
      },
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      enterpriseId: [0, [Validators.required, Validators.min(1)]],
      bussinessDocumentsClassId: [1, [Validators.required]]
    });
  }
}